import { render, staticRenderFns } from "./guandongLand.vue?vue&type=template&id=3dd37ed2&scoped=true&"
import script from "./guandongLand.vue?vue&type=script&lang=js&"
export * from "./guandongLand.vue?vue&type=script&lang=js&"
import style0 from "./guandongLand.vue?vue&type=style&index=0&id=3dd37ed2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd37ed2",
  null
  
)

export default component.exports